import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DictionarySapSymbolEntity } from '../types';

@Injectable({
  providedIn: 'root',
})
export class DictionarySapSymbolsDataService {
  url = '/api/dictionary/sap-symbol';

  constructor(private http: HttpClient) {}

  getAll(): Observable<DictionarySapSymbolEntity[]> {
    return this.http.get<DictionarySapSymbolEntity[]>(this.url);
  }

  getById(id: number): Observable<DictionarySapSymbolEntity[]> {
    return this.http.get<DictionarySapSymbolEntity[]>(`${this.url}?id=${id}`);
  }

  add(request: DictionarySapSymbolEntity): Observable<DictionarySapSymbolEntity> {
    return this.http.post<DictionarySapSymbolEntity>(this.url, request);
  }

  delete(id: number): Observable<void> {
    const parameter = { id: id };
    return this.http.delete<void>(this.url, { body: parameter });
  }
}
